
export abstract class IFileUploadService {
    abstract Upload(file:File, url?:string):Promise<string>;
}

export class FakeFileUploadService implements IFileUploadService{
    Upload(file:File, url?:string): Promise<string> {
        return Promise.resolve('url');
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/files/IFileUploadService.ts